module.exports = __webpack_public_path__ + "img/FATIMA NECKLACE GREEN.a97e66a.svg";